<template>
  <div>
    <loading v-if="load" :fullscrean="true" init="true"/>
    <div id="app" v-else-if="empresa.status === '2' || loadFranquia" :class="classes">
      <router-view/>
    </div>
    <status-empresa v-else :status="empresa.status"/>

    <div class="modal modal-loading d-block" v-if="loadingGeral" style="z-index: 2090">
      <div class="modal-content border-0">
        <div style="padding: 24px 0 32px">
          <loading :text="loadingGeral"/>
        </div>
      </div>
    </div>

    <onesignal/>

  </div>
</template>

<script>
import Loading from "../../components/Loading";
import StatusEmpresa from "../../components/StatusEmpresa";
import Onesignal from "../../components/OneSignal";

export default {
  name: 'App',
  components: {Onesignal, StatusEmpresa, Loading},
  data() {
    return {
      load: true,
      loadFranquia: true,
      user: {},
      token: '',
      empresa: {},
      classes: '',
      unidades: []
    }
  },

  methods: {
    getUnidades(callback) {
      this.$http.get(this.empresaToken + '/' + 'franquia')
        .then(response => {
          this.unidades = response.data;

          if (this.unidades.length) {
            this.$store.state.unidades = this.unidades;
            callback();

          } else {
            this.loadFranquia = false;
            this.load = false;
          }

        }, res => {
          this.loadFranquia = false;
          this.load = false;
        });
    },

    getEmpresa(token, sacola, callback) {
      const tipo_pedido = sacola ? sacola.tipo_pedido : null;
      this.$http.get('v2/empresa', { params: { token, tipo_pedido } }).then(response => {
        if (response.data && response.data.empresa && response.data.empresa.id_empresa) {
          this.empresa = response.data.empresa;
          this.$store.state.cardapio = response.data.cardapio;
          this.classes += ` theme-${this.empresa.id_theme}`;
          this.$helpers.setEmpresaStatus(this, this.empresa, () => {
            if (sacola && (!sacola.token || sacola.token === this.empresa.token) && sacola.expiracao > (new Date().getTime())) {

              if (!this.empresa.json_config.nolocal) {
                localStorage.removeItem('nolocal');
                sacola.nolocal = '';
                sacola.tipo_pedido = '1';
                sacola.origin = this.origin;
              }

              this.$store.state.sacola = sacola;
              this.$store.commit('setProdutosSacola', sacola);

            } else {
              // TODO buscar os produtos novamente caso o tipo_pedido for 3
              localStorage.removeItem('sacola');
              localStorage.removeItem('nolocal');
            }

            this.$helpers.configGoogleTag(this)
            if (callback) { callback() }
          });

        } else {
          this.load = false;
          this.$router.push('/404');
        }

      }, res => {
        if (res.data && res.data.status) {
          this.empresa.status = res.data.status
        }

        localStorage.removeItem('empresa_default');
        this.load = false;

        if (this.franquiasEnabled && this.$route.name !== 'Franquia') {
          this.$router.push('/');
        }
      });
    },

    autenticar() {
      if (!this.token) {
        this.goUrl();
        return;
      }

      const dados = { token: this.token };

      if (this.franquiasEnabled) {
        dados.id_unidade = this.empresa.id_empresa;
      }

      this.$http.post(this.empresa.token + '/login', dados)
        .then(res => {
          if (res && res.data.success) {
            this.user = res.data.dados;
            this.$store.commit('setDataUser', res.data);
            const id_cliente = this.user.id_cliente;

            this.unidades.forEach((u) => {
              this.$socket.emit('delivery_connected', id_cliente + u.token);
            });

            if (this.oneSignalIntegration) {
              setTimeout(() => {
                if (this.$OneSignal) {
                  this.$OneSignal.isPushNotificationsEnabled().then(isEnabled => {
                    if (isEnabled) {
                      this.$OneSignal.setExternalUserId(id_cliente).then(res => {
                        this.$http.post(this.empresa.token + '/' + this.token + '/cliente/onesignal', { push_habilitado: '1' }).then(res => {});
                      });
                    }
                  });
                }
              }, 5000);
            }

            this.setSentry({ email: this.user.email });
            this.goUrl();
          }

        }, res => {
          this.load = false;
          let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
          this.$swal(msg).then(() => {
            this.$store.commit('logout');

            if (res.status === 401 && this.$route.name !== 'Home') {
              this.$router.push('/home');
            }
          });
        });
    },

    goUrl() {
      const redirect = sessionStorage.getItem('redirect');
      sessionStorage.removeItem('redirect');

      if (redirect && redirect !== '/home') {
        this.$router.push(redirect);
      }

      this.load = false;
    },

    getSacola() {
      const sacolaTemp = this.$helpers.parseJSONObject(localStorage.getItem('sacola'));
      const nolocal = this.$helpers.parseJSONObject(localStorage.getItem('nolocal'));

      if (nolocal && (nolocal.expiracao > new Date().getTime())) {
        let sacola = sacolaTemp || { produtos: [], expiracao: nolocal.expiracao };
        sacola.origin = '4';
        sacola.tipo_pedido = nolocal.tipo_pedido || '2';
        this.$store.state.nolocal = nolocal;
        return sacola;

      } else if (sacolaTemp && sacolaTemp.origin !== '4') {
        sacolaTemp.expiracao = sacolaTemp.expiracao || new Date().getTime() + ((1000 * 60 * 60) * 24);
        return sacolaTemp;
      }

      localStorage.removeItem('sacola');
      localStorage.removeItem('nolocal');
      return null;
    },

    initApp() {
      this.classes = this.ios_installed ? 'ios_platform' : 'android_platform';
      this.token = localStorage.getItem("token") || false;

      if (this.$route.query.cupom) {
        localStorage.setItem('ref_cupom', this.$route.query.cupom);
      }

      const sacola = this.getSacola();

      if (this.franquiasEnabled) {
        this.getUnidades(() => {
          let empresa = localStorage.getItem('empresa_default') || null;

          if (['NaMesaFranquia','Unidade'].includes(this.$route.name)) {
            const unidade = this.unidades.find(e => e.dominio_delivery === this.$route.params.token);
            empresa = unidade ? unidade.token : null;
          }

          if (empresa) {
            localStorage.setItem('empresa_default', empresa);
            this.getEmpresa(empresa, sacola, () => {
              this.autenticar();

              if (this.$route.name === 'Unidade') {
                this.$router.push('/home');
              }
            });

            return;
          }

          this.load = false;
          sessionStorage.removeItem('redirect');
          localStorage.removeItem('empresa_default');

          if (this.$route.name !== 'Franquia') {
            if (!['NaMesaFranquia','Unidade'].includes(this.$route.name)) {
              sessionStorage.setItem('redirect', window.location.pathname + window.location.search);
            }

            this.$router.push('/');
          }
        });

      } else {
        this.loadFranquia = false;
        this.getEmpresa(this.empresaToken, sacola, () => {
          this.unidades.push(this.empresa);
          this.autenticar();
        });
      }
    }
  },

  mounted() {
    console.log('Current version: ' + this.app_version);
    this.initApp();
  },

  created() {
    sessionStorage.removeItem('cuponsReadonly');

    if (document.referrer.includes('android-app://') || sessionStorage.getItem('android-app')) {
      sessionStorage.setItem('android-app', 'true');
    }

    window.addEventListener('beforeinstallprompt', (e) => {
      this.$store.commit('setPrompt', e);
      e.preventDefault();
    });
  },

  sockets: {
    connect() {
      if (this.user.id_cliente && this.empresa.token) {
        this.unidades.forEach((u) => {
          this.$socket.emit('delivery_connected', this.user.id_cliente + u.token);
        });
      }
    }
  },

  computed: {
    loadingGeral() {
      return this.$store.state.load;
    }
  }
}
</script>

<style>
</style>
